import React, { FC, ReactElement } from 'react'

import { ConnectedInactiveUser } from '../../connectors'

const InactiveUserPage: FC = (): ReactElement => (
    <ConnectedInactiveUser />
)

export default InactiveUserPage
